import Vue from 'vue';
import { store, router, i18n, notifications, vueMeta } from './config';
import App from './App';

new Vue({
  i18n,
  store,
  router,
  notifications,
  vueMeta,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js